import ninjaApi from 'store/redux/apis/ninja.api';

export const conversionRulesApi = ninjaApi.injectEndpoints({
  tagTypes: ['ConversionRule', 'Workspace'],
  overrideExisting: true,
  endpoints: (builder) => ({
    getConversionList: builder.query({
      query: (body) => ({
        url: '/network/conversions/index',
        method: 'POST',
        body,
      }),
    }),

    conversionRulesList: builder.query({
      query: (body) => ({
        url: '/network/conversions/config/list',
        method: 'POST',
        body,
      }),
      providesTags: ['ConversionRule'],
    }),

    updateConversionRule: builder.mutation({
      query: (body) => ({
        url: '/network/conversions/config/update',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ConversionRule'],
    }),

    createConversionRule: builder.mutation({
      query: (body) => ({
        url: '/network/conversions/config/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ConversionRule'],
    }),

    deleteConversionRule: builder.mutation({
      query: (body) => ({
        url: '/network/conversions/config/delete',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ConversionRule'],
    }),

    findConversionRule: builder.query({
      query: (body) => ({
        url: '/network/conversions/config/find',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetConversionListQuery,
  useConversionRulesListQuery,
  useUpdateConversionRuleMutation,
  useDeleteConversionRuleMutation,
  useCreateConversionRuleMutation,
  useFindConversionRuleQuery,
} = conversionRulesApi;
